import { Component, Input, OnInit } from '@angular/core';
import { CLIENT_PAYMENT_STATUSES } from '../../../../../constants';
import { OrderService } from '../../../../../providers/order/order.service';

@Component({
  selector: 'app-order-payment-details-view',
  templateUrl: './order-payment-details-view.component.html',
  styleUrls: ['./order-payment-details-view.component.scss'],
})
export class OrderPaymentDetailsViewComponent implements OnInit {
  @Input() paymentStatus: string;
  @Input() createdByAdmin: boolean;

  constructor(private readonly orderService: OrderService) {

  }

  paymentStatusToDisplay: string;
  paymentStatusClasses: string[];

  ngOnInit() {
    const paymentStatusConfig = this.getPaymentStatusConfig(this.paymentStatus);
    this.paymentStatusClasses = paymentStatusConfig.classes;
    this.paymentStatusToDisplay =  paymentStatusConfig.label;
  }

  getPaymentStatusConfig(paymentStatus: string) {
    const isUnpaid = [CLIENT_PAYMENT_STATUSES.SERVICE_FEE_UNPAID].includes(paymentStatus);

    if (isUnpaid && this.createdByAdmin) {
      return {
        classes: ["payment-status--unpaid"],
        label: "Due by CarT",
      };
    }

    if (isUnpaid) {
      return {
        classes: ["payment-status--unpaid"],
        label: "PAYMENT UNPAID",
      };
    }

    if ([CLIENT_PAYMENT_STATUSES.CAR_PICKUP_PAID, CLIENT_PAYMENT_STATUSES.SERVICE_FEE_PAID].includes(paymentStatus)) {
      return {
        classes: ["payment-status--success"],
        label: this.orderService.formatStatusPayment(this.paymentStatus).toUpperCase(),
      }
    }

    return {
      classes: ["payment-status--failed"],
      label: this.orderService.formatStatusPayment(this.paymentStatus).toUpperCase(),
    };
  }
}


